import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project import
import LogoFull from './LogoFull';
import LogoMain from './LogoMain';
import LogoIcon from './LogoIcon';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ reverse, isIcon, isFull, sx, to }) => (
  <ButtonBase disableRipple component={Link} to={to ? to : null} sx={sx}>
    {isIcon ? <LogoIcon /> : isFull ? <LogoFull reverse={reverse} /> : <LogoMain reverse={reverse} />}
  </ButtonBase>
);

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  isFull: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
